export var DialogSize = /*#__PURE__*/ function(DialogSize) {
    DialogSize["m"] = "m";
    DialogSize["l"] = "l";
    DialogSize["xl"] = "xl";
    DialogSize["xxl"] = "xxl";
    return DialogSize;
}({});
export var Type = /*#__PURE__*/ function(Type) {
    Type["alert"] = "alert";
    Type["success"] = "success";
    Type["warning"] = "warning";
    Type["info"] = "info";
    return Type;
}({});
export var IconPlacement = /*#__PURE__*/ function(IconPlacement) {
    IconPlacement["center"] = "center";
    IconPlacement["left"] = "left";
    IconPlacement["right"] = "right";
    return IconPlacement;
}({});
